import React from 'react'
import {myConfig} from '../config/myConfig'
import {css} from 'glamor'
import Paper from 'material-ui/Paper'
const styles={}
const isXS = window.innerWidth < 767


class TodayView extends React.Component {

  generateRowsHoraires = () => {
    let rowsHoraires = []
    this.props.dataTodayView.times.map((time,i)=>{
      if (i<6)
        rowsHoraires.push(
          <div key={i+100} style={{padding:10,boxSizing:'border-box',position:'relative',display:'flex',justifyContent:'space-between',width:'100%', }}
            {...this.props.dataTodayView.next.french_name === time.french_name ? styles.next : {}}>
            <span {...styles.french_name}>{time.french_name}</span>
            <span style={{width:'100px'}}/>
            <span {...styles.time}>
              {time.time}
            </span>
            <span {...styles.arabic_name}>{time.arabic_name}</span>
          </div>
        )
    })
    return rowsHoraires
  }


  render() {
    return (
      <Paper zDepth={3} style={{
        width:'100%',
        display:'flex',
        justifyContent:'space-between',
        flexDirection:'column',
        color:myConfig.blue,
        boxSizing:'border-box',
        minHeight:isXS? '400px':'500px',
        padding:10,
        marginTop:10}}>
        {this.generateRowsHoraires()}

        <span style={{width:'100%',borderTop: '1px solid '+myConfig.blue}}/>

        <div style={{display:'flex'}}>

          <div style={{padding:10,boxSizing:'border-box',position:'relative',display:'flex',textAlign:'center',flexDirection:'column',justifyContent:'space-between',width:'100%', }}>
            <span {...styles.arabic_name} style={{fontSize:14}}>{this.props.dataTodayView.times[6].arabic_name}</span>
            <span {...styles.french_name} style={{fontSize:12}}>{this.props.dataTodayView.times[6].french_name}</span>
            <span {...styles.time2}> {this.props.dataTodayView.times[6].time}</span>
          </div>

          {/* <div style={{padding:10,boxSizing:'border-box',position:'relative',display:'flex',textAlign:'center',flexDirection:'column',justifyContent:'space-between',width:'100%', }}>
            <span {...styles.arabic_name} style={{fontSize:14}}>{this.props.dataTodayView.times[7].arabic_name}</span>
            <span {...styles.french_name} style={{fontSize:12}}>{this.props.dataTodayView.times[7].french_name}</span>
            <span {...styles.time2}> {this.props.dataTodayView.times[7].time}</span>
          </div> */}


        </div>



      </Paper>
    )
  }
}

styles.french_name = css({
  alignSelf: 'center',
  fontSize:'1.2em',
  '@media(max-width: 767px)':{fontSize:'0.8em'} })
styles.time = css({
  width:'100px',
  display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',
  position:'absolute',
  left: 0,
  right: 0,
  top:0,
  bottom:0,
  margin:'auto',
  fontSize:'2.0em',
  fontWeight:'bold',
  '@media(max-width: 767px)':{fontSize:'1.5em'} })
styles.time2 = css({
  width:'100px',
  display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',
  fontSize:'1.6em',
  margin:'auto',
  fontWeight:'bold',
  '@media(max-width: 767px)':{fontSize:'1.3em'} })
styles.arabic_name = css({
  fontSize:'1.6em',
  textAlign:'right',
  justifySelf:'right',
  alignSelf: 'center',
  '@media(max-width: 767px)':{fontSize:'1.1em'}})
styles.next = css({
  backgroundColor:myConfig.blue,
  color:'white',
  borderRadius:2,'@media(max-width: 767px)':{padding:5} })
styles.hijri_date = css({
  textAlign:'right',marginRight:5 })
styles.gregorian_date = css({
  textAlign:'left',marginRight:5 })

export default TodayView



// WEBPACK FOOTER //
// ./src/components/TodayView.jsx